import React, { useEffect, useRef } from "react";
import { Slider } from "@mui/material";
import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import "../../style/input/sliderInput.css";
export function SlideInput(props) {
  // Check if we should use larger size (for Show All Colors toggle)
  const isLarge = props.large || false;
  const sliderRef = useRef(null);
  
  const StyledSlider = styled(Slider)`
    color: ${(props) => (props.value ? "#54BF81" : "#E0E0D7")};
    max-width: ${isLarge ? "39px" : "26px"};
    min-width: ${isLarge ? "39px" : "26px"};
    height: ${isLarge ? "24px" : "16px"};
    padding: 0;
    cursor: pointer;

    & .MuiSlider-track {
      color: ${(props) => (props.value ? "rgba(90, 62, 255, 1)" : "#E0E0D7")};
      max-width: ${isLarge ? "39px" : "26px"};
      min-width: ${isLarge ? "39px" : "26px"};
      border-radius: ${isLarge ? "24px" : "16px"};
      cursor: pointer;
      pointer-events: auto;
    }
      
    & .MuiSlider-thumb {
      background-color: white;
      width: ${isLarge ? "18px" : "12px"};
      height: ${isLarge ? "18px" : "12px"};
      left: ${(props) => (props.value ? "68% !important" : "33% !important")};
      cursor: pointer;
      pointer-events: auto !important;
      z-index: 2;
      &:hover {
        box-shadow: 0 0 0 8px rgba(90, 62, 255, 0.16);
      }
      &:active {
        box-shadow: 0 0 0 8px rgba(90, 62, 255, 0.24);
      }
    }
    
    & .MuiSlider-rail {
      cursor: pointer;
      pointer-events: auto;
    }
    
    & .MuiSlider-root {
      cursor: pointer;
      pointer-events: auto;
    }
  `;

  const handleLabelClick = (e) => {
    // Toggle when clicking the label
    e.stopPropagation();
    if (props.onChange && !props.disabled) {
      const newValue = props.value === props.max ? props.min : props.max;
      props.onChange(e, newValue);
    }
  };

  const handleSliderChange = (e, newValue) => {
    // For binary toggles (min=0, max=1, step=1), always toggle instead of setting exact value
    // This ensures clicking anywhere on the track toggles the value
    if (props.min === 0 && props.max === 1 && props.step === 1) {
      const toggledValue = props.value === 1 ? 0 : 1;
      if (props.onChange) {
        props.onChange(e, toggledValue);
      }
    } else {
      // For other sliders, use the value as-is
      if (props.onChange) {
        props.onChange(e, newValue);
      }
    }
  };

  // Add click listener to thumb for binary toggles
  useEffect(() => {
    if (props.min === 0 && props.max === 1 && props.step === 1 && sliderRef.current) {
      const sliderElement = sliderRef.current;
      const thumb = sliderElement.querySelector('.MuiSlider-thumb');
      
      if (thumb) {
        const handleThumbClick = (e) => {
          e.stopPropagation();
          if (props.onChange && !props.disabled) {
            const toggledValue = props.value === 1 ? 0 : 1;
            props.onChange(e, toggledValue);
          }
        };
        
        thumb.addEventListener('click', handleThumbClick);
        thumb.addEventListener('mousedown', handleThumbClick);
        
        return () => {
          thumb.removeEventListener('click', handleThumbClick);
          thumb.removeEventListener('mousedown', handleThumbClick);
        };
      }
    }
  }, [props.value, props.min, props.max, props.step, props.onChange, props.disabled]);

  return (
    <div
      className={`${props.marginTop ? props.marginTop : "mt-0 "} customSlider`}
      style={{ display: 'flex', alignItems: 'center' }}
    >
      {props.leftLabel && (
        <label 
          className={"ml-2"} 
          style={{ cursor: "pointer" }}
          onClick={handleLabelClick}
        >
          {props.leftLabel}
        </label>
      )}
      <div ref={sliderRef}>
        <StyledSlider
          value={props.value}
          name={props.name}
          disabled={props.disabled}
          onChange={handleSliderChange}
          step={props.step}
          min={props.min}
          max={props.max}
        />
      </div>

      {/* <Switch
                checked={props.value}
                disabled ={props.disabled}
                onChange={(event)=>props.onChange(event)}
                inputProps={{ 'aria-label': 'controlled' }}
            />*/}
      {props.rightLabel && (
        <label 
          className={"ml-2"} 
          style={{ cursor: "pointer" }}
          onClick={handleLabelClick}
        >
          {props.rightLabel}
        </label>
      )}
    </div>
  );
}
